import { ServicePathsSettings } from '../../core/configuration/service-paths-settings';
import { GruppoAnagraficaModel } from '../models/gruppo-anagrafica-model';

export class OperationsUrlSettings {
  public static readonly nomeAnagrafiche: string = 'anagrafiche';
  public static readonly nomeTipologiche: string = 'tipologiche';
  public static readonly nomeTabelle: string = 'tabelle';
  public static readonly nomeAssociative: string = 'associative';
  public static readonly nomeUtenti: string = 'utenti';
  public static readonly nomeGruppi: string = 'gruppi';
  public static readonly nomeProfili: string = 'profili';
  public static readonly nomeFormulario: string = 'formulario';
  public static readonly nomeNotifiche: string = 'notifiche';
  public static readonly nomeConservazione: string = 'conservazione';
  public static readonly nomeScadenzario: string = 'scadenzario';
  public static readonly nomeMetadati: string = 'metadati';
  public static readonly nomeTariffe: string = 'tariffe';
  public static readonly GRUPPO_VISIBILITA_TYPE: string = 'gruppovisibilita';
  public static readonly GRUPPO_TERRITORIALE_TYPE: string = 'gruppoterritoriale';
  public static readonly GRUPPO_OPERATIVO_TYPE: string = 'gruppooperativo';
  public static readonly GRUPPO_RUOLO_TYPE: string = 'ruolo';
  public static readonly GRUPPO_SPECIALE_TYPE: string = 'gruppospeciale';
  public static readonly GRUPPO_PERMESSO_TYPE: string = 'permesso';
  public static readonly gruppiList: GruppoAnagraficaModel[] = [
  {typeGruppo: OperationsUrlSettings.GRUPPO_VISIBILITA_TYPE, desc: 'Gruppi visibilit\u00E0', descSingle: 'Gruppo visibilit\u00E0', urlGet: ServicePathsSettings.URL_GET_TEMPLATE_GRUPPI_VISIBILITA, urlPost: ServicePathsSettings.URL_ADD_GRUPPO_VISIBILITA},
  {typeGruppo: OperationsUrlSettings.GRUPPO_TERRITORIALE_TYPE, desc: 'Gruppi territoriali', descSingle: 'Gruppo territoriale', urlGet: ServicePathsSettings.URL_GET_GRUPPI_TERRITORIALI, urlPost: ServicePathsSettings.URL_ADD_GRUPPO_TERRITORIALE},
  ];

}
